import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * Nova stranica se otvara od vrha.
 *
 * Bez ovoga pregledač zadržava dotadašnji položaj klizača, pa se dokument otvoren sa dna dugačkog
 * spiska prikaže odmah na dnu i korisnik mora da se popne da bi video šta je otvorio.
 *
 * Povratak unazad je izuzetak: tamo je zapamćen položaj upravo ono što korisnik očekuje, jer se
 * vraća na mesto sa kog je otišao. Zato se dira samo `PUSH` i `REPLACE`.
 *
 * Gleda se putanja, ne cela adresa: promena stranice u spisku (`?page=3`) ne pomera klizač, jer
 * korisnik tada ostaje na istom ekranu i gleda isto zaglavlje.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();
  const tip = useNavigationType();

  useEffect(() => {
    if (tip === "POP") return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior });
  }, [pathname, tip]);

  return null;
}
